function Rules() {
  return (
    <div className="Rules">
      <h2>Game Rules</h2>

      <h3>Objective</h3>
      <p>
        Players select a category and guess as many related English words as
        possible within a time limit. The goal is to score more points than your
        friends.
      </p>

      <h3>How to Play</h3>
      <ol>
        <li>Choose a category.</li>
        <li>Take turns with your friends guessing words.</li>
        <li>Each correct guess scores points.</li>
      </ol>

        <h3>Scoring</h3>
        <p>Points are awarded based on the number of correct guesses. Bonus points are given for consecutive correct guesses.</p>

        <h3>Winning Conditions</h3>
        <p>The player with the most points at the end of the game wins. In case of a tie, a tiebreaker round is played.</p>
    </div>
  );
}

export default Rules;
